import type { PGD } from "../types";

export const pgdFusidicImpetigo: PGD = {
  id: "pgd-3b-fusidic-impetigo",
  reference: "3b",
  version: "1.0",
  drugRef: "fusidic_acid_cream",
  indication: "Localised non-bullous impetigo — second-line topical",
  validFrom: "2024-01-31",
  expiryDate: "2027-01-30",
  frameworkType: "pharmacy_first",
  population: {
    ageRange: { min: 1, max: 999 },
    pregnancyAllowed: true,
    breastfeedingAllowed: true,
    notes: "Hydrogen peroxide must be unsuitable or ineffective and impetigo must remain localised.",
  },
  duration: { days: 5 },
  doseBands: [
    {
      id: "fusidic-all",
      resolveBy: "single",
      dose: 0,
      frequency: "THREE times a day",
      comment: "Single dose band — all ages 1+.",
      formulations: [
        {
          formulationId: "fusidic-2pct-15g",
          instruction: "Apply a thin layer to the affected area(s) three times daily for 5 days",
          quantity: { tubes: 1, label: "1 × 15g tube" },
        },
        {
          formulationId: "fusidic-2pct-30g",
          instruction: "Apply a thin layer to the affected area(s) three times daily for 5 days",
          quantity: { tubes: 1, label: "1 × 30g tube" },
        },
      ],
    },
  ],
  preSupplyChecks: [
    { id: "ex-consent-refused", question: "Has the patient/carer refused consent?" },
    { id: "ex-fusidic-allergy", question: "Hypersensitivity to fusidic acid or any component of the formulation?" },
    { id: "ex-failed-treatment", question: "Failed previous oral antimicrobial treatment for this episode of impetigo?" },
    { id: "ex-active-skin", question: "Currently active underlying skin condition?", hint: "e.g. uncontrolled eczema, contact dermatitis, scabies, chickenpox, eczema herpeticum" },
    { id: "ex-open-wounds", question: "Any open wounds affecting the application area or immediate vicinity?" },
    { id: "ex-fire-risk", question: "Inability to stay away from open or naked flames?", hint: "e.g. smokers — risk of severe burns" },
    { id: "ex-breastfeeding-breast", question: "Breastfeeding with impetigo lesion(s) on the breast(s)?" },
  ],
  cautions: [
    { id: "caution-breastfeeding", text: "Breastfeeding (lesions not on breast) — avoid direct contact between infant and lesions. Wash hands after applying and before touching infant." },
    { id: "caution-eyes", text: "Caution near eyes, mucous membranes, or nasal cavity — excipients may be irritant and cause contact dermatitis." },
  ],
  counselling: [
    "Apply a thin layer to the affected area(s) three times daily for 5 days",
    "Wash hands thoroughly after each application",
    "Good hygiene is important to reduce spread",
  ],
  counsellingPoints: [
    { text: "Apply a thin layer to the affected area(s) three times daily for 5 days" },
    { text: "Wash hands thoroughly after each application" },
    { text: "Good hygiene is important to reduce spread — avoid touching lesions, wash hands frequently, do not share towels or flannels" },
    { text: "Keep away from school/nursery/work until lesions are crusted and dried, or 48 hours after starting treatment" },
    { text: "Return to pharmacy if symptoms worsen at any time or do not improve after completing the 5-day course" },
  ],
  outcomeLinkRefs: ["bad-impetigo-leaflet", "nhs-impetigo"],
};
